import { useEffect, useState } from "react";

import CarrinhoItemDesktop from "./CarrinhoItemDesktop/CarrinhoItemDesktop";
import CarrinhoItemMobile from "./CarrinhoItemMobile/CarrinhoItemMobile";

export default function CarrinhoItem({
  produto,
  produtos,
  setProdutos,
  limitecrdt,
}) {

  const [isMobile, setIsMobile] =
    useState(window.innerWidth <= 600);

  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);

  const saldo =
    Number(produto.saldototal) || 0;

  const [quantidade, setQuantidade] =
    useState(Number(produto.quantidade));

  const [mensagem, setMensagem] =
    useState("");

  const [tipoMensagem, setTipoMensagem] =
    useState("erro");

  const caixa =
    Boolean(produto.ehCaixa);

  const pesoPorPeca =
    Boolean(produto.ehPesoPorPeca);

  const pesoCaixa =
    Number(produto.pesoCaixa ?? 0);

  const pesoPeca =
    Number(produto.pesoPeca ?? 0);

  const precoUnitario =
    Number(
      produto.precoUnitario ??
      produto.valorunitario ??
      produto.precovenda
    );

  useEffect(() => {

    setQuantidade(
      Number(produto.quantidade)
    );

  }, [produto.quantidade]);

  useEffect(() => {

    if (!mensagem) return;

    const timer =
      setTimeout(() => {
        setMensagem("");
      }, 3000);

    return () =>
      clearTimeout(timer);

  }, [mensagem]);

  function atualizarCarrinho(
    novaQuantidade
  ) {

    const atualizados =
      produtos.map((item) => {

        if (
          item.codProduto !==
          produto.codProduto
        ) {
          return item;
        }

        return {
          ...item,
          quantidade: novaQuantidade,
        };

      });

    setProdutos(atualizados);

    localStorage.setItem(
      "carrinho",
      JSON.stringify(atualizados)
    );

    window.dispatchEvent(
      new Event("carrinhoAtualizado")
    );

  }

  function alterarQuantidade(valor) {

    let qtd =
      Number(valor);

    if (
      isNaN(qtd) ||
      qtd < 1
    ) {
      qtd = 1;
    }

    if (qtd > saldo) {

      qtd = saldo;

      setTipoMensagem("erro");
      setMensagem(
        "Saldo insuficiente."
      );

    }

    const totalPedido =
      produtos.reduce((total, item) => {

        const quantidadeItem =
          item.codProduto === produto.codProduto
            ? qtd
            : Number(item.quantidade);

        const multiplicador =
          item.ehCaixa
            ? Number(item.pesoCaixa)
            : item.ehPesoPorPeca
              ? Number(item.pesoPeca)
              : 1;

        const precoItem =
          Number(
            item.precoUnitario ??
            item.valorunitario ??
            item.precovenda
          );

        return (
          total +
          quantidadeItem *
          multiplicador *
          precoItem
        );

      }, 0);

    /*
    if (totalPedido > Number(limitecrdt)) {

      setTipoMensagem("erro");

      setMensagem(
        "O valor do pedido excede o limite de crédito disponível."
      );

      return;

    }
    */

    setMensagem("");

    setQuantidade(qtd);

    atualizarCarrinho(qtd);

  }

  function aumentar() {

    alterarQuantidade(
      quantidade + 1
    );

  }

  function diminuir() {

    alterarQuantidade(
      quantidade - 1
    );

  }

  function remover() {

    const atualizados =
      produtos.filter(
        (item) =>
          item.codProduto !==
          produto.codProduto
      );

    setProdutos(atualizados);

    localStorage.setItem(
      "carrinho",
      JSON.stringify(atualizados)
    );

    window.dispatchEvent(
      new Event("carrinhoAtualizado")
    );

  }

  const multiplicador =
    caixa
      ? pesoCaixa
      : pesoPorPeca
        ? pesoPeca
        : 1;

  const subtotal =
    precoUnitario *
    quantidade *
    multiplicador;

  const propsComuns = {

    produto,
    saldo,

    quantidade,
    mensagem,
    tipoMensagem,

    caixa,
    pesoPorPeca,
    pesoCaixa,
    pesoPeca,

    precoUnitario,
    subtotal,

    aumentar,
    diminuir,
    remover,
    alterarQuantidade,

  };

  if (isMobile) {

    return (
      <CarrinhoItemMobile
        {...propsComuns}
      />
    );

  }

  return (
    <CarrinhoItemDesktop
      {...propsComuns}
    />
  );

}